<template>
  <form-model title="结束工单" width="400" ref="formModel">
    <Alert slot="topcontent" type="warning" show-icon>
        强制结束需谨慎
        <template #desc>
           该功能属于不需要司机执行任务，负责人强制结束任务，相关司机将不产生任务数据
        </template>
    </Alert>
    <Button slot="btn" type="primary" @click="qianzi">结束工单</Button>
  </form-model>
</template>
<script>
import fields from "./forms/fields";
export default {
  data() {
    return {
      title: "",
      forms: [
        {
          title: "工单号",
          key: "title",
          key1: "title",
          type: "Input",
          span: 24,
          readonly: true,
          required: true,
        },
      ],
      item: {
        id: "",
        optSource: 1,
      },
      searchItem: {},
    };
  },
  methods: {
    //https://cloud.ly-gps.com/cloud-rmm-server-dpm/repair
    reach(v) {
      console.log(v);
      this.item.title = v.title;
      this.item.job = v.nodeName;
      this.item.id = v.docId;
      this.searchItem.id = v.docId;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    qianzi() {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.item = a;
      this.utils.loading(this, "加载中");
      console.log(this.item);
      this.axios({
        method: "post",
        url: this.axios.dpc + "/apply/finish",
        data: this.item,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          this.$refs.formModel.close();
          this.$emit("ok");
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/diaodu/endTask.vue